const heroSlider = {
    off: "Flat 35% off",
    product: 'On every products',
    desc: "Discover a wide range of genuine medicines and health products online. Discover a wide range of genuine medicines online.",
    explore: 'Explore Now',
}
export default heroSlider